import { Component } from 'react';
import {
  BlockStack,
  Pagination,
  Button,
  Card,
  Page,
  Text,
  Badge,
} from '@shopify/polaris';
import SkeltonLoading from "../../../components/SkeltonLoading";
import {
  withRouter
} from 'react-router-dom';
import { connect } from 'react-redux'
import utils from '../../../utils/utils';
import { reqAddAdsClickNum } from '../../../api';
//轮播图
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from "swiper";
import 'swiper/css'; // 公共引入轮播图样式
import 'swiper/css/bundle'; // 公共引入轮播图样式
import './index.scss';
import Language from '../../../i18n/Language';
import { store } from '../../../redux/store';
import FooterTrustHelp from '../../../components/FooterTrustHelp';
import { cloneDeep } from 'lodash';
const t = Language;
const imgOnloadArr = [];
class indexClass extends Component {

  state = {
    bannerList: [],
    appList: [],
    loadingPage: true,
    clickNum: 1,
  };

  componentDidMount() {
    // 判断是否已经缓存到redux中 如果缓存了则使用缓存的值
    let _store = store.getState().public.AllAdverData;
    this.getSeoExpertService(_store);
  }

  // 获取额外服务
  getSeoExpertService = (res) => {
    if (res.ack === 1) {
      let _data = res.data;
      let bannerList = [];
      for (let i = 0; i < (_data.propose_banner).length; i += 3) {
        bannerList.push((_data.propose_banner).slice(i, i + 3));
      }
      this.setState({
        bannerList,
        appList: _data.propose_list,
        loadingPage: false
      })
    }
  }

  // 埋点
  addClickNums = async (id) => {
    const params = {
      ad_id: id,
      click_num: 1,
    }
    await reqAddAdsClickNum(params);
  }

  // 返回首页
  goBack = () => {
    utils.routeJump(this, '/dashboard')
  }

  // 图片加载
  onloadImg = (e) => {
    imgOnloadArr.push(e.target.currentSrc);
  }

  // 监听
  slideChangeSet = (e) => {
    let n = cloneDeep(this.state.clickNum);
    let _current = e === 'prev' ? n -= 1 : n += 1
    this.setState({
      clickNum: _current
    })
  }

  render() {
    const {
      bannerList,
      appList,
      clickNum,

    } = this.state;

    // 新轮播图
    const AppSwiperList = bannerList.length > 0 ? <Card>
      <BlockStack gap={400}>
        <Text variant="headingMd" as="h2">{t("Top Picks by SEOAnt")}</Text>
        <div className='app_swiper_adver'>
          <Swiper
            slidesPerView={"auto"}
            loop={false}
            autoplay={false}
            modules={[Navigation]}
            pagination={{
              clickable: false,
            }}
            navigation={{
              prevEl: '#previousURL',
              nextEl: '#nextURL',
            }}
            touchRatio={0.5}
            spaceBetween={10}
            initialSlide={0}
          >
            {bannerList.map((item, index) => {
              return <SwiperSlide key={index}>
                <div className='banner_child_main'>
                  {
                    item.map(child => {
                      return <div key={child.id} className='banner_child' onClick={() => {
                        this.addClickNums(child.id);
                        window.open(child.jump_url);
                      }}>
                        <Card padding={0}>
                          <div className='child_img'><img src={child.img_url} alt='' /></div>
                          <div className='child_text'>
                            <BlockStack gap={400}>
                              <BlockStack gap={200}>
                                <Text variant="headingMd" as="h2">{child.app_name}</Text>
                                <p className='Every_Card_Desc' style={{ fontSize: 12, lineHeight: '1.4' }}>{child.desc}</p>
                              </BlockStack>
                              {
                                Boolean(child.button_text) && <div><Button>{child.button_text}</Button></div>
                              }
                            </BlockStack>
                          </div>
                        </Card>
                      </div>
                    })
                  }
                </div>
              </SwiperSlide>
            })}
          </Swiper>
        </div>
        {/* 分页 */}
        {
          bannerList.length > 1 ? <Pagination
            hasPrevious={clickNum > 1}
            onPrevious={() => this.slideChangeSet('prev')}
            hasNext={clickNum < bannerList.length}
            onNext={() => this.slideChangeSet('next')}
          /> : null
        }
      </BlockStack>
    </Card> : null

    // 轮播图
    // const BannerList = bannerList.length > 0 ? <Card>
    //   <Swiper
    //     slidesPerView={"auto"}
    //     loop={bannerList.length > 1 ? true : false}
    //     autoplay={{
    //       delay: 5000,
    //       disableOnInteraction: false
    //     }}
    //     modules={[Autoplay, Navigation]}
    //     pagination={{
    //       clickable: true,
    //     }}
    //     touchRatio={0.5}
    //     spaceBetween={10}
    //     initialSlide={0}
    //   >
    //     {bannerList.map((item, index) => {
    //       return <SwiperSlide key={index}>
    //         <div className='banner_main'>
    //           {
    //             item.length === 1 ? item.map(banner => {
    //               return <div key={banner.id} className='banner_item_one' onClick={() => {
    //                 this.addClickNums(banner.id);
    //                 window.open(banner.jump_url);
    //               }}>
    //                 <img src={banner.img_url} alt='' />
    //               </div>
    //             }) :
    //               (item.length === 2 ? item.map(banner => {
    //                 return <div key={banner.id} className='banner_items' onClick={() => {
    //                   this.addClickNums(banner.id);
    //                   window.open(banner.jump_url);
    //                 }}>
    //                   <img src={banner.img_url} alt='' />
    //                 </div>
    //               }) : null)
    //           }
    //         </div>
    //       </SwiperSlide>
    //     })}
    //   </Swiper>
    // </Card> : null

    // App列表
    const AppList = appList.length > 0 ? <Card>
      <BlockStack gap={400}>
        <BlockStack gap={100}>
          <Text variant="headingMd" as="h2">{t("Elevate your website with these essential apps")}</Text>
          <p className='Every_Card_Desc' style={{ fontSize: 12 }}>{t("Exclusive partner discounts to maximize your performance.")}</p>
        </BlockStack>
        <div className='app_all'>
          {
            appList.map(app => {
              return <Card key={app.id}>
                <div className='app_item'>
                  <div className='app_top'>
                    <div className='app_img'>
                      <img src={app.img_url} onLoad={this.onloadImg} alt='' />
                      {
                        imgOnloadArr.includes(app.img_url) ? null : <img src='/load_img.png' alt='' className='loading_img' />
                      }
                    </div>
                    <div className='app_name_dis'>
                      <Text variant='headingMd' as='h2'>{app.app_name}</Text>
                      {
                        Boolean(app.discount_label) && <div><Badge tone="info">{app.discount_label}</Badge></div>
                      }

                    </div>
                  </div>
                  <div className='app_info'>
                    {/* <Text variant='headingMd' as='h2'>{app.app_name}</Text> */}
                    <p className='app_desc'>{app.desc}</p>
                  </div>
                  <div className='app_btn'><Button variant='plain' onClick={() => {
                    this.addClickNums(app.id);
                    window.open(app.jump_url);
                  }}>{app.button_text}</Button></div>
                </div>
              </Card>
            })
          }
        </div>
      </BlockStack>
    </Card> : null

    // 底部
    const FooterHelpBox = <FooterTrustHelp />

    // app容器
    const pageMain = <BlockStack gap={400}>
      {AppSwiperList}
      {/* {BannerList} */}
      {AppList}
    </BlockStack>

    // 最终内容
    const pageContentLast = this.state.loadingPage ? <SkeltonLoading /> :
      <div className='integration_page'>
        <Page
          backAction={{
            content: t("Recommended Apps"),
            onAction: this.goBack,
          }}
          title={t("Recommended Apps")}
        >
          <title>SEOAnt - Integration</title>
          {pageMain}

          {/* 底部 */}
          {FooterHelpBox}
        </Page>
      </div>

    return pageContentLast;
  }
}

const mapStateToProps = state => {
  return state
}

indexClass = connect(
  mapStateToProps,
)(indexClass);

export default withRouter(indexClass);
